import React from 'react';
import laptop from '../../img/png/menu_agencies.png';
import { AiOutlineCheckCircle } from 'react-icons/ai';

const MenuAgencies = ({ isActive }) => {
  return (
    <>
      <div className={`menu_agencies ${isActive}`}>
        <div className='menu_agencies_container d-flex-row justify-content-between'>
          <div className='menu_agencies_container_left d-flex-col gap-1'>
            <p className='text-gray'>
              ONE Market, is purposefully designed as a plug and play platform
              to work directly into any agency’s current workflow.
            </p>
            <p className='text-gray'>
              The AI builds a media strategy for any brand, product, or category
              by sourcing segments and cohorts from the largest audience
              repository in the world.
            </p>
            <img src={laptop} alt='background img' />
          </div>
          <div className='menu_agencies_container_right d-flex-col'>
            <div className='bullet d-flex-col'>
              <div className='bullet_item d-flex-row align-items-center gap-2'>
                {/* <span>1</span> */}
                <AiOutlineCheckCircle />
                <h3 className='text-subtitle'>
                  Reach your ideal target persona in just 3 steps
                </h3>
              </div>
              <div className='bullet_item d-flex-row align-items-center gap-2'>
                {/* <span>2</span> */}
                <AiOutlineCheckCircle />
                <h3 className='text-subtitle'>
                  Full-control over the entire workflow
                </h3>
              </div>
              <div className='bullet_item d-flex-row align-items-center gap-2'>
                {/* <span>3</span> */}
                <AiOutlineCheckCircle />
                <h3 className='text-subtitle'>Automated media plan creation</h3>
              </div>

              <div className='paragraph d-flex-col gap-2'>
                <p className='text-gray'>
                  ONE Market can be used as a standalone targeting and
                  activation solution, or connected to an existing client DSP
                  seat. The media and activation strategy is automatically
                  transformed into an objective-based media plan.
                </p>
                <p className='text-gray'>
                  <span> ONE Market Auto: </span>the platform does everything
                  for you.
                </p>
                <p className='text-gray'>
                  <span> ONE Market Pro: </span>
                  the parameters can be adjusted for each campaign.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuAgencies;
